<template>
  <ValidationObserver v-slot="{ invalid }">

    <Loader v-if="isProcessing" cover/>

    <!-- DROPZONE-->
    <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <import-excel accept=".csv, .xlsx, .xls"
                        :importOptions="importOptions"
                        :onSuccess="onloadDataInTable"/>
        </div>

    </div>

    <div class="vs-row mb-2">
      <div class="vx-col w-full">
          <h5 class="pt-2"> {{ $t('live-class-record.import-to') }} </h5>
      </div>
    </div>

    <!-- ACADEMIC PERIOD & CLASS SECTION-->
    <div class="vx-row mb-2">

      <div class="vx-col sm:w-2/6 w-1/3">
        <ValidationProvider v-slot="{ errors }" :name="$t('student-enroll.academic-period')" rules="required">
          <label class="text-sm opacity-75">{{ $t('student-enroll.academic-period') + ' *' }}</label>
          <v-select v-model="selectedAcademicPeriod"
                    :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :options="academicPeriods"
                    class="mb-4 md:mb-0"
                    label="periodCode"
                    @input="onAcademicPeriodChange"
                    selectOnTab>
          </v-select>
          <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

      <div class="vx-col sm:w-4/6 w-2/3 mb-2">
        <ValidationProvider v-slot="{ errors }" :name="$t('class-room.class-section')"
                            rules="required">
          <label class="text-sm opacity-75">{{ $t('class-room.class-section') + ' *' }}</label>
          <v-select v-model="selectedClassSection"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :options="classSections"
                    class="mb-4 md:mb-0"
                    label="sectionNo"
                    selectOnTab
                    :clearable="false"
                    @input="handlerSelectClassSection">

            <!--label option-->
            <template #selected-option="option">
              <div class="flex items-center justify-between">
                <div class="flex items-center mr-4">
                  {{ $t('class-over-view.section-short') }}: {{ option.sectionNo }}
                  {{ $t('class-over-view.learn-span-no-short') }}: {{ option.learnSpanNo }}
                </div>

                <vs-chip :color="option.studentInClassQty > 0 ? 'success':'danger'">
                  {{ $t('vdo-set-topic.student-qty') }}: {{ option.studentInClassQty }}
                </vs-chip>

<!--                <vs-chip :color="option.yeaLinkImportDataQty > 0 ? 'success':'danger'">
                  {{ $t('live-class-record.import-qty') }}: {{ option.yeaLinkImportDataQty }}
                </vs-chip>-->

                <vs-chip color="success">
                  {{ $t('upload.upload-status-code.success') }}: {{ option.yeaLinkImportDataSuccessQty }}
                </vs-chip>

                <vs-chip color="danger">
                  {{ $t('upload.upload-status-code.fail') }}: {{ option.yeaLinkImportDataFailQty }}
                </vs-chip>
              </div>
            </template>

            <!--option list-->
            <template v-slot:option="option">
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  {{ $t('class-over-view.section-short') }}: {{ option.sectionNo }}
                  {{ $t('class-over-view.learn-span-no-short') }}: {{ option.learnSpanNo }}
                </div>

                <vs-chip :color="option.studentInClassQty > 0 ? 'success':'danger'">
                  {{ $t('vdo-set-topic.student-qty') }}: {{ option.studentInClassQty }}
                </vs-chip>


                <vs-chip color="success">
                  {{ $t('upload.upload-status-code.success') }}: {{ option.yeaLinkImportDataSuccessQty }}
                </vs-chip>

                <vs-chip color="danger">
                  {{ $t('upload.upload-status-code.fail') }}: {{ option.yeaLinkImportDataFailQty }}
                </vs-chip>

<!--                <vs-chip :color="option.yeaLinkImportDataQty > 0 ? 'success':'danger'">
                  {{ $t('live-class-record.import-qty') }}: {{ option.yeaLinkImportDataQty }}
                </vs-chip>-->
              </div>
            </template>

          </v-select>

          <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

    </div>

    <vs-alert :active.sync="showWarning"
              class="mb-4"
              closable
              close-icon="icon-x" color="warning" icon="icon-alert-triangle"
              icon-pack="feather">
      {{ warningMessage || $t('live-class-record.read-file-fail') }}
    </vs-alert>

    <vs-alert :active.sync="showSuccess"
              class="mb-4"
              closable
              close-icon="icon-x" color="primary" icon="icon-check-circle"
              icon-pack="feather">
      {{ $t('upload.upload-file-success', {allQty: tableData.length, successCount, failCount}) }}
    </vs-alert>

    <vs-tabs v-model="selectedTab">

      <!-- IMPORT DATA -->
      <vs-tab :label="$t('zoom-import.tab-data')">
        <vs-table-mod :data="tableData"
                      :max-items="tableConfig.maxItemsPerPage"
                      pagination
                      search>

          <template slot="header">
            <div class="inline-flex">

              <vx-tooltip :text="$t('general.upload')">
                <vs-button
                  :disabled="invalid || !tableData || tableData.length === 0"
                  class="ml-2"
                  color="primary" icon="icon-upload" icon-pack="feather" radius type="filled"
                  @click="onUploadClick">
                </vs-button>
              </vx-tooltip>

            </div>
          </template>

          <template slot="thead">
            <!-- Zoom repeats 'Duration (minutes)', so index is the only unique key. -->
            <vs-th v-for="(heading, indexheading) in header" :key="indexheading" :sort-key="heading">{{ heading }}</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr v-for="(tr, indextr) in data" :key="indextr" :data="tr">
              <vs-td v-for="(col, indexcol) in data[indextr]" :key="indexcol + col" :data="col">
                <span
                  :class="col === $t('upload.upload-status-code.success') ? 'text-success':col === $t('upload.upload-status-code.fail') ? 'text-danger':''">
                  {{ col }}
                </span>
              </vs-td>
            </vs-tr>
          </template>

        </vs-table-mod>
      </vs-tab>

      <!-- PER-PERSON SUMMARY -->
      <vs-tab :label="$t('zoom-import.tab-summary')">
        <zoom-summary-table :summary="summary"/>
      </vs-tab>

    </vs-tabs>

  </ValidationObserver>
</template>

<script>
import store from '@/store';
import vSelect from 'vue-select'
import ImportExcel from "@/components/excel/ImportExcel.vue"
import vsTableMod from "@/components/vuesax-mod/components/vsTable/vsTable.vue";

import AcademicPeriod from '@/store/modules/common-data/academic-period';
import AcademicPeriodConfig from '@/store/modules/common-data/academic-period-config/index';
import ClassSection from '@/store/modules/courses/class-section/index';
import YeaLinkImportData from '@/store/modules/yea-link-import-data/index';

import {tableConfig} from "@/utils/table";
import {createNamespacedHelpers} from "vuex";
import {notificationType, showLocalNotification, showStateNotification} from "@/utils/notification";
import {confirmUpload} from "@/utils/dialogs";
import {createHelpers} from "vuex-map-fields";
import {
  mapZoomRowToImportData,
  stripSpaces,
  summarizeByStudent,
  validateZoomHeader,
  validateZoomRows,
} from '@/utils/zoom-cdr';

if (!store.state.YeaLinkImportData) store.registerModule(`YeaLinkImportData`, YeaLinkImportData);
if (!store.state.AcademicPeriod) store.registerModule(`AcademicPeriod`, AcademicPeriod);
if (!store.state.AcademicPeriodConfig) store.registerModule(`AcademicPeriodConfig`, AcademicPeriodConfig);
if (!store.state.ClassSection) store.registerModule(`ClassSection`, ClassSection);

const {
  mapFields: mapYeaLinkImportDataFields,
} = createHelpers({
  getterType: `YeaLinkImportData/getField`,
  mutationType: `YeaLinkImportData/updateField`,
});

const {
  mapActions: mapYeaLinkImportDataActions,
} = createNamespacedHelpers(`YeaLinkImportData`);
const {
  mapActions: mapAcademicPeriodActions,
} = createNamespacedHelpers(`AcademicPeriod`);
const {
  mapActions: mapAcademicPeriodConfigActions,
} = createNamespacedHelpers(`AcademicPeriodConfig`);
const {
  mapActions: mapClassSectionActions,
} = createNamespacedHelpers(`ClassSection`);

export default {
  name: "UploadLearnTimeCard",
  props:[
    'vdoSet',
    'vdoSetUnit',
    'vdoSetTopic',
  ],
  components:{
    ImportExcel,
    vSelect,
    vsTableMod,
    ZoomSummaryTable: () => import('@/components/excel/ZoomSummaryTable.vue'),
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
  },
  computed:{
    ...mapYeaLinkImportDataFields({
      yeaLinkImportDataProcessing: 'processing',
      yeaLinkImportDataSuccess: 'success',
      yeaLinkImportDataError: 'error'
    }),
  },
  data() {
    return {
      selectedTab: 0,
      isProcessing: false,
      tableConfig: tableConfig,
      tableData: [],
      header: [],
      sheetName: "",
      showWarning: false,
      showSuccess: false,
      warningMessage: '',
      summary: [],

      successCount: 0,
      failCount: 0,

      importOptions: {
        raw: true,
        defval: '',
        // dateNF: 'FMT 22'
      },

      academicPeriods: [],
      classSections: [],
      selectedAcademicPeriod: {},
      selectedClassSection: null,
      currentAcademicPeriodConfig: {},
      deleteOldRecord: false,
    }
  },
  watch: {
    yeaLinkImportDataProcessing(data) {
      this.isProcessing = data;
    },
    yeaLinkImportDataSuccess(data) {
      showStateNotification(this.$vs, data);
    },
    yeaLinkImportDataError(data) {
      showStateNotification(this.$vs, data);
    },
  },
  methods:{
    //---------------------------------------- State Function ------------------------------------------------------//
    ...mapYeaLinkImportDataActions({
      addUploadYeaLinkLearnTime: 'addUploadYeaLinkLearnTime',
    }),
    ...mapAcademicPeriodActions({
      getAcademicPeriods: 'getAcademicPeriods',
    }),
    ...mapAcademicPeriodConfigActions({
      getCurrentAcademicPeriodConfig: 'getCurrentAcademicPeriodConfig',
    }),
    ...mapClassSectionActions({
      getCLassSectionsForUploadLearnTime: 'getCLassSectionsForUploadLearnTime',
    }),
    //---------------------------------------- Event Function ------------------------------------------------------//
    handlerSelectClassSection(){
      this.clearWarning();
    },
    onloadDataInTable({results, header, meta}) {
      this.clearWarning();
      this.warningMessage = '';
      this.header = header;
      this.tableData = results;
      this.summary = [];
      this.sheetName = meta.sheetName;

      const headerCheck = validateZoomHeader(header);
      if (!headerCheck.valid) {
        this.warningMessage = this.$t('zoom-import.zoom-header-invalid', {
          columns: headerCheck.missing.join(', '),
        });
        this.showWarning = true;
        this.tableData = [];
        return;
      }

      const rowCheck = validateZoomRows(results);
      if (!rowCheck.valid) {
        this.warningMessage = this.$t('zoom-import.zoom-rows-invalid', {
          count: rowCheck.badCells.length,
          cells: rowCheck.badCells
            .map(cell => '#' + cell.rowNo + ' ' + cell.column)
            .join(', '),
        });
        this.showWarning = true;
        this.tableData = [];
        return;
      }

      this.summary = summarizeByStudent(results);
      showLocalNotification(this.$vs, this.$t('general.success'), this.$t('upload.read-file-success'), notificationType.SUCCESS);
    },
    async onUploadClick() {
      await confirmUpload(this.$vs, this.saveExamUpload);
    },
    async onAcademicPeriodChange(){
      this.showSuccess = false;
      this.showWarning = false;
      this.selectedClassSection = null;

      await this.setClassSection();
    },
    //---------------------------------------- Local Function ------------------------------------------------------//
    async saveExamUpload() {
      this.isProcessing = true;
      this.showSuccess = false;
      let preparedData = this.prepareDataBeforeUpload(this.tableData);
      let result = await this.addUploadYeaLinkLearnTime(preparedData);
      if (result) {

        //remove __typeName
        this.tableData.forEach(item => {
          // Match on name alone. The backend reports failures per PARTICIPANT,
          // not per row: it de-duplicates with _.uniqBy(..., 'participantName')
          // (add-upload-yearlink-learn-time.js:268) before building its result,
          // so the row it returns carries only one of that student's join/leave
          // pairs. Comparing times too left every other row of a failed
          // participant looking like a success. It also strips every space from
          // participantName, hence stripSpaces on both sides.
          let failRecord = result.resultAddUploadYeaLinkImportData.find(failItem => {
            return stripSpaces(item['Name (original name)']) === stripSpaces(failItem.participantName)
          })
          if (failRecord) {
            item['status'] = this.$t(failRecord.status);
            item['remark'] = this.$t(failRecord.remark);
          } else {
            item['status'] = this.$t('upload.upload-status-code.success');
            item['remark'] = '';
          }

          delete item['__typeName'];
        })

        // this.selectedClassSection.yeaLinkImportDataQty = result.successCount;
        this.successCount = result.successCount;
        this.failCount = result.failCount;

        if (this.header.indexOf(this.$t('upload.status')) < 0) {
          this.header.push(this.$t('upload.status'));
        }
        if (this.header.indexOf(this.$t('upload.remark')) < 0) {
          this.header.push(this.$t('upload.remark'));
        }

        this.showSuccess = true;
      }
      this.isProcessing = false;
    },
    prepareDataBeforeUpload(data) {
      return {
        classSectionId: this.selectedClassSection.id,
        vdoSetUnitId: this.vdoSetUnit.id,
        vdoSetTopicId: this.vdoSetTopic.id,
        deleteOldRecord: this.deleteOldRecord,
        yeaLinkImportDataArray: data.map(mapZoomRowToImportData),
      }
    },
    async initData() {
      this.academicPeriods = await this.getAcademicPeriods();
      this.currentAcademicPeriodConfig = await this.getCurrentAcademicPeriodConfig();

      if (this.academicPeriods && this.academicPeriods.length > 0) {
        this.selectedAcademicPeriod = this.academicPeriods.find(item => {
          return item.periodCode === this.currentAcademicPeriodConfig.learnPeriodCode
        });

        await this.setClassSection();
      }
    },
    async setClassSection(){
      const payload = {
        academicPeriodId: this.selectedAcademicPeriod.id,
        vdoSetId: this.vdoSet.id,
        vdoSetTopicId: this.vdoSetTopic.id,
      }
      this.classSections = await this.getCLassSectionsForUploadLearnTime(payload);
    },
    clearWarning(){
      this.showSuccess = false;
      this.showWarning = false;
    }
  },
  async beforeMount() {
    await this.initData();
  },
}
</script>

<style scoped>

</style>
